import {
    TextField,
    Button,
    CircularProgress,
    Box,
    FormHelperText,
} from "@mui/material";
import DialogComponent from "components/DialogComponent";
import { useEffect, useState } from "react";
import { useAddCommentOnFileMutation } from "store/slices/apis/dmsSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";


const CommentModal = ({
    open,
    onClose,
    fileId,
}) => {
    const [addFileComment, { isLoading }] = useAddCommentOnFileMutation();
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            comment: "",
        },
        validationSchema: Yup.object({
            comment: Yup.string()
                .trim()
                .required("Comment is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const result = await addFileComment({
                    fileId,
                    comment: values.comment,
                }).unwrap();
                if (result.status === "Success") {
                    openNotification("Comment Added Successfully", "success")
                    resetForm();
                    onClose();
                }

            } catch (err) {
                openNotification(err?.data?.message || "Comment Add Failed")
                console.error("Failed to add comment", err);
            }
        },
    });

    const openNotification = (msg, type = "error", duration = 5000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    useEffect(() => {
        if (!open) {
            formik.resetForm();
        }
    }, [open]);

    return (
        <DialogComponent
            title="Add Comment"
            open={open}
            handleClose={onClose}
        >
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{ p: 1 }}>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        name="comment"
                        label="Comment"
                        value={formik.values.comment}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.comment &&
                            Boolean(formik.errors.comment)
                        }
                        sx={{ mt: 1 }}
                    />

                    {formik.touched.comment && formik.errors.comment && (
                        <FormHelperText error>
                            {formik.errors.comment}
                        </FormHelperText>
                    )}
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1.5,
                        mt: 3,
                        pt: 2,
                        borderTop: "1px solid #F3F4F6",
                    }}
                >
                    <Button
                        onClick={onClose}
                        sx={{
                            textTransform: "none",
                            color: "#F15744",
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "25px",
                            fontWeight: 500,
                            px: "20px",
                            py: "15px",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isLoading}
                        sx={{
                            backgroundColor: "#00344C",
                            borderRadius: "25px",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            color: "#FFFFFF",
                            px: "20px",
                            py: "15px",
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress size={20} sx={{ color: "#fff" }} />
                        ) : (
                            "Submit"
                        )}
                    </Button>
                </Box>
            </form>
        </DialogComponent>
    );
};

export default CommentModal;
